import React from 'react';
import _ from 'lodash';

import {cx} from '../util';

import {XIcon} from './svg';

const CloseButton = ({className = '', onClick = _.noop, disabled = false}) => (
  <button
    type="button"
    aria-label="Close"
    className={cx(`
      text-gray-300
      focus-within:text-gray-400
      hover:text-gray-400
      min-h-[24px]
      min-w-[24px]
      p-1
      `,
    className)}
    onClick={onClick}
    disabled={disabled}
  >
    <XIcon className="block h-full w-full fill-current transition-all" />
  </button>
);

export default CloseButton;
